/*
*###############################################################################
*Module Name                   : DPSearchBox.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"

const DPMobilePopUp = (props) => {


    useEffect(() => {
        setCurrentPage(1);
    }, [props.isOpen]);

    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 10;


    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1);
    }

    return (
        <div>
            <Modal
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <table className="table table-bordered table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ width: "100px" }}>Date</th>
                                        <th style={{ width: "150px" }}>User</th>

                                        <th>Remark</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {props.data.map((item, index) => {
                                        return (
                                            <tr key={index} style={{ cursor: 'pointer' }} onClick={() => {
                                                props.handleMobileManRowClick(item)
                                            }}>
                                                <td>{item.sC_DATE.slice(0, 10)}</td>
                                                <td>{item.sC_USER}</td>
                                                <td>{item.sC_SHELFID}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className="mt-1">
                        <Col md="12">
                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(props.data.length / postsPerPage)}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                forcePage={currentPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-center pagination-sm'}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>

        </div>
    );
}

export default DPMobilePopUp;